import React from 'react';
import './OverlayLoadingIndicator.less';

let overlayLoading: OverlayLoadingInterface | null = null;

export type OverlayLoadingInterface = {
    show: () => void;
    dismiss: () => void;
}

export type OverlayLoadingIndicatorProps = {
    initialVisibility: boolean;
}

function setOverlayLoading(ref: OverlayLoadingInterface) {
    if (!overlayLoading) {
        overlayLoading = ref;
    }
}

function showLoading() {
    if (!overlayLoading) {
        console.log("show overlay loading not set.");
        return;
    }

    overlayLoading.show();
}

function dismissLoading() {
    if (!overlayLoading) {
        console.log("dismiss overlay loading not set.");
        return;
    }

    overlayLoading.dismiss();
}

const OverlayLoadingIndicator = React.forwardRef<OverlayLoadingInterface, OverlayLoadingIndicatorProps>(
    (
        {
            initialVisibility,
        },
        ref
    ) => {
        const [visible, setVisible] = React.useState(initialVisibility);

        React.useImperativeHandle(ref, () => {
            return {
                show: () => {
                    setVisible(true);
                },
                dismiss: () => {
                    setVisible(false);
                },
            };
        });

        return (
            <>
                <div className={`overlay-loading-indicator-${visible ? 'show' : 'dismiss'}`}/>
            </>
        );
    }
)

export {OverlayLoadingIndicator, setOverlayLoading, showLoading, dismissLoading};
